import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// Phase 7 sub-bucket 19 — InsightsBar 30-day aggregate hook.
//
// Backs `GET /api/settings/notifications/insights` which surfaces
// `loadNotificationInsights` (deliveries-by-channel state=sent / opens /
// unique partners / unique people). Gated server-side on
// `notifications.read`.
//
// Invalidations:
//   - useCreateNotificationRule / useUpdateNotificationRule /
//     useDeleteNotificationRule / useTestSendNotification flush
//     queryKeys.settings.notificationInsights() — the dispatcher's routing
//     decisions just changed, so the next refresh should pick up the trend.

export type NotificationInsights = {
  emailsSent: number;
  emailsOpened: number;
  uniquePartnersReached: number;
  uniquePeopleReached: number;
};

export function useNotificationInsights() {
  return useQuery<NotificationInsights, ApiClientError>({
    queryKey: queryKeys.settings.notificationInsights(),
    queryFn: () =>
      apiFetch<NotificationInsights>("/settings/notifications/insights"),
    // 30-day rollup doesn't change minute-by-minute; cache for a minute to
    // avoid hammering the worker when the page is left open.
    staleTime: 60_000,
  });
}
